import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useUserProfile = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { toast } = useToast();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        console.log("Starting to fetch user profile...");
        const { data: { user }, error: userError } = await supabase.auth.getUser();
        
        if (userError) {
          console.error("Error fetching user:", userError);
          setError(userError);
          return;
        }

        if (!user) {
          console.error("No authenticated user found");
          setError(new Error("No authenticated user found"));
          return;
        }

        console.log("Current user ID:", user.id);

        const { data: profileData, error: profileError } = await supabase
          .from('profiles')
          .select('first_name, last_name, email')
          .eq('id', user.id)
          .maybeSingle();
        
        if (profileError) {
          console.error("Error fetching profile:", profileError);
          setError(profileError);
          return;
        }

        console.log("Profile data retrieved:", profileData);
        
        if (!profileData) {
          console.error("No profile data found for user:", user.id);
          setError(new Error("Profile data not found"));
          return;
        }

        console.log("Setting first name to:", profileData.first_name);
        setFirstName(profileData.first_name || "");
        setLastName(profileData.last_name || "");
        setEmail(profileData.email || user.email || "");
      } catch (error) {
        console.error("Error in fetchUserProfile:", error);
        setError(error as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [toast]);

  return { firstName, lastName, email, loading, error };
};